import { UserPreferencesState } from '@hooks/UserPreferences';
import { KEY_USER_PREFERENCES } from '@utils/constants';
import { getLocalStorage } from '@utils/localStorage';

export const FULLSTORY_DEBUG_ENABLED = Boolean(
  (getLocalStorage<UserPreferencesState>(KEY_USER_PREFERENCES) ?? {})
    .fullstoryDebug,
);
